<!-- Label Template (for left position) -->
<ng-template #labelTemplate>
  @if (props.label) {
    <label [class.form-label]="true"
           [class.radio-label-before]="labelPosition === 'left'"
           [style.width]="labelPosition === 'left' ? (labelWidth || null) : null">
      {{ props.label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
</ng-template>

<!-- Radio Options Template -->
<ng-template #radioOptionsTemplate>
  @for (option of radioOptions; track option.value) {
    <div class="form-check">
      <input [id]="id + '_' + $index"
             type="radio"
             [formControl]="formControl"
             [formlyAttributes]="field"
             [value]="option.value"
             class="form-check-input"
             [class.is-invalid]="showError" />
      <label [attr.for]="id + '_' + $index"
             class="form-check-label">
        {{ option.label }}
      </label>
    </div>
  }
</ng-template>

<!-- Description and Error Template -->
<ng-template #descriptionErrorTemplate>
  @if (props.description) {
    <small class="form-text text-muted d-block">{{ props.description }}</small>
  }

  @if (showError) {
    <div class="invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
</ng-template>

<!-- Main Layout -->
<div class="mb-3">
  @if (labelPosition === 'left') {
    <div class="radio-inline-wrapper">
      <div class="radio-inline-container">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
        <div class="radio-inline-field">
          <ng-container *ngTemplateOutlet="radioOptionsTemplate"></ng-container>
          <ng-container *ngTemplateOutlet="descriptionErrorTemplate"></ng-container>
        </div>
      </div>
    </div>
  } @else {
    @if (props.label) {
      <label [class.form-label]="true">
        {{ props.label }}
        @if (required) {
          <span class="text-danger">*</span>
        }
      </label>
    }
    <ng-container *ngTemplateOutlet="radioOptionsTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="descriptionErrorTemplate"></ng-container>
  }
</div>